import { StyleSheet } from 'react-native';
import { fontFamily, color, fontWeight } from '../Styles/Base';
export default StyleSheet.create({
    textStyle: {
        color: color.gray,
        fontFamily: fontFamily.copy,
        fontWeight: fontWeight.medium,
        backgroundColor: 'transparent',
    },
});
